import type { NetworkGraph, StateSnapshot } from '@mrt/graph';

/**
 * Relative by default so the server serves its own SPA. The Capacitor build
 * loads from the app container and must be given an absolute origin at build
 * time.
 */
const BASE = (import.meta.env['VITE_API_BASE'] as string | undefined)?.replace(/\/$/, '') ?? '';

async function getJson<T>(path: string, timeoutMs: number): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    signal: AbortSignal.timeout(timeoutMs),
    headers: { accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`${path} -> HTTP ${res.status}`);
  return (await res.json()) as T;
}

export const fetchGraph = (): Promise<NetworkGraph> => getJson<NetworkGraph>('/api/graph', 15_000);
export const fetchState = (): Promise<StateSnapshot> => getJson<StateSnapshot>('/api/state', 8_000);
